module.exports = __webpack_public_path__ + "img/PL08215.93ea6e10.png";